// import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { Table } from 'antd';
import axios from 'axios'
import { Tab } from 'bootstrap';
import React, { useEffect, useState } from 'react'
import APIURL from '../api/apiClient';
// import DataTable from "react-data-table-component";

const ServiceCategoryTable = () => {
    const [categories, setCategories] = useState('');
    const [perPage, setPerPage] = useState(8)

    const columns = [
        {
            title: 'S.No',
            dataIndex: 'serial',
            key: 'serial',
            width: 90,
            render: (text, record, index) => <div>{index + 1}</div>,
        },
        {
            title: 'Category Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Brand',
            dataIndex: 'brand',
            key: 'brand'
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
        },
    ];

    useEffect(() => {
        const fetchdata = async () => {
            axios.get(`${APIURL.baseURL}/servicecategory.php`)
                .then(result => {
                    setCategories(result.data)
                })
                .catch(error => console.log(error))
        }
        fetchdata();
    }, [])


    return (
        <div>

            <div
                style={{
                    maxWidth: '100%',
                    overflowX: 'auto',
                    margin: '0px 0',
                    border: '1px solid #ddd',
                    borderRadius: '8px',
                    // gap: '50px', 
                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                    padding: '10px',
                }}
            >

                <div style={{ marginTop: '20px' }}>
                    <h3 style={{ fontSize: '24px', marginBottom: '16px', fontWeight: '600' }}>Service Category Table</h3>

                    <Table
                        columns={columns}
                        dataSource={categories}
                        pagination={{
                            pageSize: perPage,
                            showSizeChanger: true,
                            pageSizeOptions: ['7', '10'],
                            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
                            onShowSizeChange: (current, size) => setPerPage(size),
                        }}
                        rowKey={(record, index) => index} // Use a unique ID field if available
                        style={{
                            fontSize: '15px',
                            textAlign: 'center',
                               background: 'linear-gradient( #F5EFFF, #FFFFFF)',
                        }}
                    />
                </div>

            </div>
        </div>
    )
}

export default ServiceCategoryTable
